import Immutable from 'immutable';
import { handleActions } from 'redux-actions';
import { TYPES as ANNUAL_AVAILABILITY_TYPES } from 'actions/annualAvailabilityActions';
import { TYPES as SEARCH_RESULTS_TYPES } from 'actions/searchResultsActions';
import { TYPES as DIMENSIONS_TYPES } from 'actions/dimensionsActions';
import { TYPES as DAY_OF_MONTH_TYPES } from 'actions/dayOfMonthActions';
import { TYPES as SEARCH_UNIT_TYPES } from 'actions/searchUnitActions';
import { TYPES as HOTEL_DETAILS_TYPES } from 'actions/hotelDetailsActions';
import { checkForNestedProperty } from 'utils/utils';

const initialState = Immutable.Map();

function reducerCallback(state, action) {
  let response = state;
  if (checkForNestedProperty(action, 'response.result.dimensions')) {
    response = state.merge(action.response.result.dimensions);
  }

  return response;
}

export default handleActions({
  [ANNUAL_AVAILABILITY_TYPES.ANNUAL_AVAILABILITY_SUCCESS]: reducerCallback,
  [SEARCH_RESULTS_TYPES.SEARCH_RESULTS_SUCCESS]: reducerCallback,
  [DIMENSIONS_TYPES.DIMENSIONS_RESULTS_SUCCESS]: reducerCallback,
  [DAY_OF_MONTH_TYPES.DAY_OF_MONTH_SUCCESS]: reducerCallback,
  [SEARCH_UNIT_TYPES.DAY_OF_MONTH_SUCCESS]: reducerCallback,
  [HOTEL_DETAILS_TYPES.HOTEL_DETAILS_SUCCESS]: reducerCallback,
}, initialState);



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/dimensionsResultReducer.js
 **/